import {connect} from "react-redux";

import {dismissNotification, getNotifications} from "@client/features/notifications";

import {Notifications} from "@client/shared/components/Notifications";
import {RootState} from "@client/store";

const mapStateToProps = (state: RootState) => ({
    notifications: getNotifications(state),
});

const mapDispatchToProps = {
    dismissHandler: dismissNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
